<template>
  <div
    v-if="loaded"
    class="page"
  >
    <div class="page__sidebar">
      <grossing-side-bar
        :counters="sidebarSummary"
        @update-option="onClickUpdateFilter($event)"
        @click-add-filter="onClickAddFilter"
        @view-all-toggled="onViewAllToggled"
      />
    </div>
    <div class="page__main">
      <router-view
        ref="mainContent"
        class="page__main-content"
        @updateSummary="loadSidebarSummary"
      />
    </div>
  </div>
</template>

<script>
import GrossingSideBar from './sideBar/GrossingSideBar'
import sideBarStore from './sideBar/grossingSideBarStore'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import { portionState } from '@/api/resources/entityState/portion-state'
import grossingSampleService from '@/modules/grossingModule/services/grossingSampleService'

export default {
    name: 'GrossingIndex',
    components: {
        GrossingSideBar
    },
    data() {
        return {
            loaded: false,
            sideBarState: sideBarStore.state,
            sidebarSummaryInterval: null,
            sidebarSummary: null,
            predefinedFiltersSummary: null,
            modalUiComponent: 'uicomponent.grossing.modalconfig'
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    async mounted() {
        try {
            await Promise.all([
                sideBarStore.loadConfig(),
                this.loadModalConfiguration(),
                grossingSampleService.getSampleStates(),
                portionState.loadStates()
            ])

            await this.loadSidebarSummary()
            this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadSidebarSummary)

            if (!this.sideBarState.config.defaultOptionId) {
                this.sideBarState.config.defaultOptionId = sideBarStore.getDefaultConfig().defaultOptionId
            }
        } finally {
            this.loaded = true
        }
    },
    beforeDestroy() {
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
        this.cleanSearchStateGlobalMixin()
        sideBarStore.setSelectedOption(null)
    },
    methods: {
        async loadModalConfiguration() {
            const customConfig = await customConfigResource.get(this.modalUiComponent)
            if (customConfig) {
                await this.$_setModalConfirmationState('grossingModalsState', customConfig.config)
            }
        },
        async loadSidebarSummary() {
            const viewAllEnabled = !!this.sideBarState.config.viewAllEnabled
            const summaryRequest = sideBarStore.getSummaryRequest()
            this.sidebarSummary = await grossingSampleService.getSummary(this.labId, summaryRequest, viewAllEnabled)
        },
        onClickAddFilter() {
            if (this.$refs.mainContent.onSideBarClickAddFilter) {
                this.$refs.mainContent.onSideBarClickAddFilter()
            }
        },
        onClickUpdateFilter(option) {
            if (this.$refs.mainContent.onSideBarClickUpdateFilter) {
                this.$refs.mainContent.onSideBarClickUpdateFilter(option)
            }
        },
        onViewAllToggled() {
            if (this.$refs.mainContent.onViewAllToggled) {
                this.$refs.mainContent.onViewAllToggled()
            }
        }
    }
}

</script>
